import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ label = "Back" }) => {
  const navigate = useNavigate();

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 14px',
    margin:"15px 0",
    backgroundColor: '#286a94',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'background-color 0.2s ease-in-out',
  };

  const iconStyle = {
    marginRight: '8px',
    fontSize: '16px',
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.backgroundColor = '#366a81'; // darker version for hover
  };

  const handleMouseOut = (e) => {
    e.currentTarget.style.backgroundColor = '#286a94';
  };

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      style={buttonStyle}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <span style={iconStyle}><ArrowBackIcon/></span>
      {label}
    </button>
  );
};

export default BackButton;
